import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=1251a4b7"
import script from "./ModalComment.vue?vue&type=script&lang=js"
export * from "./ModalComment.vue?vue&type=script&lang=js"
import style0 from "./ModalComment.vue?vue&type=style&index=0&id=1251a4b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports